import { FilterDefn } from '../index';

export const keyForOption = (option: FilterDefn) => {
    return option.valueList ? option.valueList.sort().join(',') : option.value;
};
